<template>
    <form
        v-on:submit.prevent="submit"
        class="form-group"
        :class="{ 'full-width': fullWidth }"
        @keyup.enter="submit"
    >
        <input
            ref="searchInput"
            class="form-control search-input"
            type="text"
            :placeholder="placeholder"
            :value="modelValue"
            v-on:input="onInput"
            v-on:blur="onBlur"
            @keyup.backspace="onBackspace"
        />
        <button
            type="submit"
            class="search-button"
            :disabled="!modelValue || modelValue === ''"
            aria-label="Search"
        >
            <i class="fi fi-search hoverable"></i>
        </button>
        
        <i v-if="modelValue" class="fi fi-x i-x hoverable" v-on:click="clear"></i>
    </form>
</template>

<script>
export default {
    name: 'SearchBar',
    props: {
        modelValue: {
            // v-model
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            default: 'Search',
        },
        fullWidth: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            focus: false,
            previousValue: '',
            clearInProgress: false,
        };
    },
    emits: ['update:modelValue', 'submit', 'blur', 'clear'],
    methods: {
        onInput(e) {
            this.previousValue = this.modelValue;
            this.$emit('update:modelValue', e.target.value);
        },
        clear() {
            this.clearInProgress = true;
            this.$emit('update:modelValue', '');
            this.$emit('clear', '');

            setTimeout(() => {
                this.clearInProgress = false;
            }, 200);
        },
        submit() {
            this.$emit('submit', this.modelValue);
        },
        onBlur() {
            setTimeout(() => {
                if (!this.clearInProgress) {
                    this.$emit('blur', this.modelValue);
                }
            }, 100);
        },
        // triggers clear when backspace is pressed and the input is empty
        onBackspace(e) {
            if (e.target.value === '' && this.previousValue !== '') {
                this.$emit('clear', this.modelValue);
            }
        },
    },
};
</script>

<style scoped>
form {
    display: inline-block;
    padding: 0;
    margin: 0;
    position: relative;
    width: min(100%, 432px);
}

form.full-width {
    max-width: none;
    display: block;
    margin: 0;
}

button,
i {
    position: absolute;
    right: 0.875rem;
    top: 50%;
    transform: translateY(-50%);
    inline-size: 1.125rem;
    block-size: 1.125rem;
}

.fi-search:before {
    font-size: 1.125rem;
}

.i-x {
    right: var(--space-10);
}

.search-disabled {
    color: var(--neutral-700);
    cursor: text;
}

.search-input {
    padding-right: 3.75rem;
}

.search-button {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    inline-size: 1.125rem;
    block-size: 1.125rem;
}
</style>
